(() => {
  if (window.alveronzBundleRounding) return;
  window.alveronzBundleRounding = true;
  const initialize = (root) => {
    root.querySelectorAll('quantity-breaks').forEach((element) => {
      if (element.dataset.alvRoundingReady) return;
      element.dataset.alvRoundingReady = 'true';
      const data = element.querySelector('script[type="application/json"]');
      if (!data) return;
      const variants = JSON.parse(data.textContent);
      const prices = new Map(variants.map((variant) => [String(variant.id), variant]));
      const money = (cents) => typeof formatMoney === 'function'
        ? formatMoney(cents, element.dataset.moneyFormat, true)
        : new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(cents / 100);
      let scheduled = false;
      const render = () => {
        scheduled = false;
        element.querySelectorAll('label.quantity-break').forEach((label) => {
          const quantity = Number(label.dataset.quantity);
          const percent = Math.round((1 - Number(label.dataset.percentageLeft)) * 100);
          const selectors = Array.from(label.querySelectorAll('.quantity-break__selector-item'));
          const base = Number(element.dataset.basePrice);
          let total = 0;
          let comparison = 0;
          for (let index = 0; index < quantity; index += 1) {
            const variant = prices.get(selectors[index]?.dataset.selectedId);
            const price = variant ? Number(variant.price) : base;
            total += price - Math.floor((price * percent + 0.000001) / 100);
            comparison += label.dataset.compareMode === 'compare_price' && variant?.compare_at_price > price
              ? Number(variant.compare_at_price) : price;
          }
          total = Math.max(0, total - Number(label.dataset.fixedDiscount || 0));
          label.querySelectorAll('.variant-price-update').forEach((target) => {
            const template = target.dataset.text || '';
            const text = template.replaceAll('[price]', money(total))
              .replaceAll('[compare_price]', comparison > total ? money(comparison) : '')
              .replaceAll('[amount_saved]', money(comparison - total))
              .replaceAll('[amount_saved_rounded]', money(Math.round((comparison - total) / 100) * 100));
            if (target.textContent.trim() !== text.trim()) target.textContent = text;
          });
        });
      };
      const schedule = () => {
        if (scheduled) return;
        scheduled = true;
        requestAnimationFrame(render);
      };
      new MutationObserver(schedule).observe(element, {
        subtree: true, childList: true, attributes: true,
        attributeFilter: ['data-selected-id', 'data-base-price', 'data-percentage-left', 'data-fixed-discount']
      });
      element.addEventListener('change', schedule);
      render();
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize(document));
  else initialize(document);
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
})();
